import React, { Fragment } from 'react';
import { Typography, Hidden } from '@material-ui/core';

const withFiled = WrappedComponent => ({
    input,
    fillText,
    hideFillAt,
    ...rest
}) => (
    <WrappedComponent
        {...rest}
        input={input}
        endAdornments={(
            <Fragment>
                <Hidden only={hideFillAt}><Typography>{fillText}</Typography></Hidden>
            </Fragment>
        )}
    />
);

export default withFiled;
